import { useEffect, useState } from 'react'

type IData = { key: string; value: string }[][]

interface IProps {
  contentArr: IData
}
function RenderKeyValue(props: IProps) {
  const { contentArr } = props
  const [arr, setArr] = useState(contentArr)
  const prefix = 'render-box2'
  useEffect(() => {
    setArr(contentArr)
  }, [contentArr])
  const renderContentLi = () => {
    return arr.map((item: any, index: number) => {
      if (item.length >= 2) {
        return (
          <li className={`${prefix}-item`} key={index}>
            <div className={`${prefix}-item-one`}>
              <span className={`${prefix}-item-key`}>{item[0].key}</span>
              <span className={`${prefix}-item-value`}>{item[0].value}</span>
            </div>
            <div className={`${prefix}-item-two`}>
              <span className={`${prefix}-item-key`}>{item[1].key}</span>
              <span className={`${prefix}-item-value`}>{item[1].value}</span>
            </div>
          </li>
        )
      }
      else {
        return (
          <li className={`${prefix}-item`} key={index}>
            <span className={`${prefix}-item-key`}>{item[0].key}</span>
            <span title={item[0].value} className={`${prefix}-item-value`}>{item[0].value}</span>
          </li>
        )
      }
    })
  }
  return <div className={`${prefix}`}>{renderContentLi()}</div>
}

export default RenderKeyValue
